// Third party library
import _ from "lodash";
import React from "react";

// Models
import SessionModel from "../../../../../../data/models/sessions";

// Redux
import { connect } from "react-redux";
import { closeModal, openModal } from "../../../../../../redux-store/modal";
import { closeLoader, openLoader } from "../../../../../../redux-store/loader";

// Components
import { Segment } from "semantic-ui-react";
import RuleForm from "./components/form";
import I18n from "../../../../../../i18n";

const defautltRule = {
  name: "",
  conditions: {},
  event: {},
  status: true
}

class SequenceRulesEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rule: null
    };
  }

  componentDidMount() {

    const ruleId = this.props.match.params.ruleId;

    if (ruleId === 'new') {
      this.setState({ rule: _.cloneDeep(defautltRule) });
      return;
    }

    // Try to get rule from props.rules (if parent passed it)
    const fromProps = _.get(this.props, 'rules', null);
    const found = Array.isArray(fromProps) ? _.find(fromProps, ({ _id }) => _id === ruleId) : null;

    if (found) {
      this.setState({ rule: _.cloneDeep(found) });
      return;
    }

    // Otherwise fetch from API
    this.fetchRule(ruleId);

  }

  fetchRule = async ruleId => {

    const { openLoader, closeLoader, openModal, closeModal } = this.props;

    let message = {
      headerTitle: "Error",
      title: _.get(I18n, 't("messages.modal.commonError")', 'Error'),
      buttons: [
        {
          text: I18n.t('actions.accept'),
          callback: () => closeModal()
        }
      ]
    };

    try {
      openLoader();
      const resp = await SessionModel.getRule(ruleId);
      if (resp && resp.data) {
        this.setState({ rule: _.cloneDeep(resp.data) });
      } else {
        openModal(message);
      }
    } catch (error) {
      console.error('error getRule', error);
      openModal(message);
    } finally {
      closeLoader();
    }

  }

  render() {

    const rule = this.state.rule;

    if (!rule) return null;

    return (
      <Segment>
        <RuleForm
          initialValues={rule}
          history={this.props.history}
          {...this.props}
        />
      </Segment>
    )

  }

}

export default connect(null, { closeModal, openModal, openLoader, closeLoader })(SequenceRulesEdit);
